import { render, staticRenderFns } from "./GetSupportBtn.vue?vue&type=template&id=557cb1bc"
import script from "./GetSupportBtn.vue?vue&type=script&lang=ts"
export * from "./GetSupportBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports